import type { FeatureRequestView, RemindersPayload, RequestsPayload } from "@boem/core/shared";
import { call } from "./api.ts";

/** The "For you" panel and "Request a feature" (phase 4a). */
export const remindersApi = {
  list: () => call<RemindersPayload>("GET", "/api/reminders"),
  read: (id: string) => call("POST", `/api/reminders/${encodeURIComponent(id)}/read`, {}),
  dismiss: (id: string) => call("POST", `/api/reminders/${encodeURIComponent(id)}/dismiss`, {}),
  readAll: () => call("POST", "/api/reminders/read-all", {}),
  pause: (paused: boolean) => call("POST", "/api/reminders/pause", { paused }),
  requests: () => call<RequestsPayload>("GET", "/api/requests"),
  request: (input: { title: string; body: string; items: number[] }) => call<FeatureRequestView>("POST", "/api/requests", input),
};
